import moment from 'moment'
import {DIMENSION_OPTIONS, FILTER_STATE, getItem, setItem} from '../helpers/config'
import chart from './chart'

const dimensionOptions = [
    // {
    //     label: "Country",
    //     value: "country",
    //     schemaName: ".country",
    //     options: country.getCountryList()
    // },
    {
        clients: ["expo"],
        label: "Country",
        value: "expoCountry",
        segmentName: ".expo{}ClientSegment",
        type: "select",
        options: [
            {
                value: "UAE",
                label: "UAE"
            },
            {
                value: "KSA",
                label: "KSA"
            }
        ]
    }
]

const initialFilterState = {
    // dateRange: [moment('2021-10-01'), moment('2021-10-31')],
    dateRange: [moment().startOf('month'), moment().endOf('month')],
    expoCountry: 'UAE'
}

const updateDimensionOption = (optionValue, updatedOption) => {
    let dOptions = getDimensionOptions()
    let index = dOptions.findIndex(option => option.value == optionValue)
    if (index !== -1) {
        dOptions[index] = { ...dOptions[index], ...updatedOption }
    }

    setDimensionOptions(dOptions)
}

const getDimensionOptions = () => {
    let dOptions = getItem(DIMENSION_OPTIONS)
    if (!dOptions) {
        dOptions = dimensionOptions
        setDimensionOptions(dOptions)
    }
    return dOptions
}

const setDimensionOptions = (dOptions) => {
    setItem(dOptions || dimensionOptions, DIMENSION_OPTIONS)
}

const getDimensionOptionsForClient = (clientName) => {
    return getDimensionOptions().filter(dOption =>
        dOption.clients.some(client => client == clientName)
    )
}

const getDimensionOption = (dimensionOptionValue) => {
    return getDimensionOptions().find(dOption =>
        dOption.value == dimensionOptionValue
    )
}

const getFilterState = () => {
    let fState = getItem(FILTER_STATE)
    if (!fState) {
        fState = initialFilterState
        setFilterState(fState)
    }
    return fState
}

const setFilterState = (fState) => {
    setItem(
        fState || initialFilterState,
        FILTER_STATE
    )
}

const mapValueToFilter = (dashboardItem, state, clientName) => {
    let tableName = chart.getTableName(dashboardItem.id)
    return Object.keys(state)
        .filter(key => key !== 'dateRange' && key !== "expoCountry")
        .map(key => {
            console.log("key", key)
            console.log("dimension options", getDimensionOptionsForClient(clientName))
            let dimension = getDimensionOptionsForClient(clientName)
                .find(dimensionOption =>
                    dimensionOption.value == key)
            console.log("dimension", dimension)
            let updatedValues = [dimension?.options.find(option => option.value == state[key])?.label]
            console.log("updated values", updatedValues)
            return {
                member: `${tableName}.${key}`,
                operator: 'equals',
                values: updatedValues
            }
        })
        .filter(item =>
            !!item.values && item.values.length > 0 && !item.values[0].toLowerCase().includes('all')
        )

}

export default {
    initialFilterState,
    getDimensionOptions,
    setDimensionOptions,
    updateDimensionOption,
    mapValueToFilter,
    getFilterState, setFilterState,
    getDimensionOptionsForClient,
    getDimensionOption
}

